import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DOUBLE_OPT_IN_ENABLED = createFcmDetails('double_opt_in_enabled', {
	owner: 'supporters pack',
	context: 'petition page',
	description:
		'For guests only, indicates whether to display a reminder to check the email inbox to confirm the signature.',
	import: false,
});
